import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sa-kpidashboard',
  styleUrls: ['./kpidashboard.component.scss'],
  templateUrl: './kpidashboard.component.html',
})
export class KPIDashboardComponent implements OnInit {
  constructor() {}
  public ngOnInit(): void {}
}
